import './EmailDeliveryWarning.css';
import { Trans } from 'react-i18next';
import { Note } from '@src/components/Note/Note';
import { Link } from '@src/components/Link/Link';
import { supportEmail } from '@src/site';
import { emailDeliveryIssueDomain } from './emailDeliveryIssues';

/** Advisory only: delivery trouble must not prevent access to an existing account. */
export function EmailDeliveryWarning({ email, id }: { email: string; id?: string }) {
  const domain = emailDeliveryIssueDomain(email);
  if (!domain) return null;
  return (
    <div className="email-delivery-warning" id={id} role="status" aria-live="polite">
      <Note tone="warning" icon={null} testId="email-delivery-warning">
        <Trans
          i18nKey="emailDelivery.warning"
          values={{ domain }}
          components={{ contact: <Link variant="inline" href={`mailto:${supportEmail()}`} /> }}
        />
      </Note>
    </div>
  );
}
